<div class="overlay">
    <div class="dialog-progress-spinner">
        <div>
            <h4 mat-dialog-title> {{ msg }} </h4>
        </div>
        <div style="text-align: center;">
            <mat-spinner style="margin:0 auto;" diameter="50" class="custom-spinner"></mat-spinner>
        </div>
    </div>
</div>
